import { render, staticRenderFns } from "./MailLogList.vue?vue&type=template&id=edfb7498&scoped=true"
import script from "./MailLogList.vue?vue&type=script&lang=js"
export * from "./MailLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfb7498",
  null
  
)

export default component.exports